import appSettings from "../settings/appSettings";
import fetchRequest from "./fetchRequest";
import { parseUserFriendlyMessage, wvusLogger } from "../helpers";
import { getPhrase } from "../languages";
const { orderApiConfig } = appSettings;

class AddPhotoError extends Error {
  response: {
    message?: string;
  };
}

export const requestAddPhotoApi = async (apiPayload) => {
  const baseUrl = orderApiConfig.baseUrl;
  const url = `${baseUrl}/api/wvus/orders/add-photo`;

  try {
    const response = await fetchRequest(url, {
      method: "POST",
      cache: "no-cache",
      mode: "cors",
      timeout: 45 * 1000,
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify(apiPayload)
    });

    if (!response.ok) {
      const addPhotoErrorResp = await response.json();
      const userMessage = parseUserFriendlyMessage(
        addPhotoErrorResp,
        getPhrase("errors.general_error_volunteer")
      );

      const err = new Error(userMessage);
      throw err;
    }

    const addPhotoResp = await response.json();

    if (
      !addPhotoResp ||
      !addPhotoResp.success ||
      !addPhotoResp?.data?.orderId ||
      !addPhotoResp?.data?.orderRef
    ) {
      const err = new AddPhotoError(getPhrase("errors.invalid_add_photo_response"));
      err.response = (addPhotoResp && addPhotoResp) || "";
      throw err;
    }

    return addPhotoResp;
  } catch (err) {
    wvusLogger.log(err, wvusLogger.getLogLevelNames().ERROR);
    return Promise.reject(err);
  }
};
